import React, { useEffect, useState } from 'react';
import './settings.css';
import Dashheader from '../Dash-header/Dashheader';
import axios from 'axios';
import { END_URL, IMG_URL } from '../../config';
import Sidebar from '../dashboard/Sidebar';
import UserFooter from '../footer/UserFooter.jsx';

const SettingsPage = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [activityLog, setActivityLog] = useState([]);
  const [expanded1, setExpanded] = useState(false);
  const [dynamicContent, setDynamicContent] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [is2FAEnabled, setIs2FAEnabled] = useState(false);



  const [show2FAModal, setShow2FAModal] = useState(false);
  const [qrCodeUrl, setQRCodeUrl] = useState('');
  const [twoFACode, setTwoFACode] = useState('');
  const [verificationEmail, setVerificationEmail] = useState(userProfile?.email || '');
  const [twoFAError, setTwoFAError] = useState('');
  const [twoFASuccess, setTwoFASuccess] = useState('');
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [infoModalMessage, setInfoModalMessage] = useState('');




  const handleEnable2FA = async () => {
    try {
      const token = sessionStorage.getItem('authToken');
      const res = await axios.get(`${END_URL}2fa`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // Assuming backend returns the QR code url in res.data.qrCodeUrl or similar
      setQRCodeUrl(res.data.qrCodeUrl || '');
      setVerificationEmail(userProfile?.email || '');
      setTwoFACode('');
      setTwoFAError('');
      setTwoFASuccess('');
      setShow2FAModal(true);
    } catch (error) {
      console.error('Failed to fetch 2FA QR code', error);
      alert('Could not initiate 2FA setup.');
    }
  };



  const fetchActivityLogs = async () => {
    try {
      const token = sessionStorage.getItem('authToken');
      const response = await axios.get(`${END_URL}user-activity-logs`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setActivityLog(response.data);
    } catch (error) {
      console.error("Error fetching activity logs:", error);
    }
  };



  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const token = sessionStorage.getItem('authToken');
        const response = await axios.get(`${END_URL}users`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUserProfile(response.data);

        const isEnabled = response.data.isAuthy === 1 || response.data.isAuthy === '1';
        setIs2FAEnabled(isEnabled);

        console.log('User profile:', response.data);
        console.log('is2FAEnabled:', isEnabled);
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    fetchUserProfile();
  }, []);


  const handleDisable2FA = async () => {
    try {
      const token = sessionStorage.getItem('authToken');
      const response = await axios.post(`${END_URL}2fa`, {
        otp: 'none',
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        setIs2FAEnabled(false);
        setInfoModalMessage('Two-factor authentication disabled successfully.');
        setShowInfoModal(true);
      } else {
        setInfoModalMessage('Failed to disable 2FA.');
        setShowInfoModal(true);
      }
    } catch (error) {
      console.error('Error disabling 2FA:', error);
      setInfoModalMessage('An error occurred disabling 2FA.');
      setShowInfoModal(true);
    }
  };



  const handleDeactivationRequest = async () => {
    if (window.confirm("Are you sure you want to deactivate your account?")) {
      try {
        const token = sessionStorage.getItem('authToken');
        const response = await axios.post(`${END_URL}deactivate-account-request`, {}, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (response.status === 200) {


          // Remove token and redirect
          sessionStorage.removeItem('authToken');
          window.location.href = '/'; // or your login page route (e.g., '/login')
        } else {
          alert("Failed to notify admin.");
        }
      } catch (err) {
        console.error("Deactivation error:", err);
        alert("Something went wrong while requesting deactivation.");
      }
    }
  };



  useEffect(() => {
    fetchActivityLogs();
  }, []);



  useEffect(() => {
    const fetchDynamicContent = async () => {
      try {
        const response = await axios.get(`${END_URL}dynamic-page`);
        setDynamicContent(response.data.data); // Assuming your API returns { data: ... }
      } catch (error) {
        console.error('Failed to fetch dynamic content:', error);
      }
    };

    fetchDynamicContent();
  }, []);





  const handlePasswordUpdate = async () => {
    setError('');
    setMessage('');

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('All password fields are required.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New Password and Confirm Password do not match.');
      return;
    }

    try {
      const token = sessionStorage.getItem('authToken');
      const response = await axios.post(`${END_URL}change-password`, {
        current_password: currentPassword,
        new_password: newPassword,
        new_password_confirmation: confirmPassword,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.status === 200) {
        setMessage('Password updated successfully.');
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setTimeout(() => {
          setMessage('');
        }, 2000); // hides message after 2 seconds
      }
      else {
        setError(response.data.message || 'Failed to update password.');
      }
    } catch (err) {
      setError(
        err.response?.data?.message ||
        'An error occurred while updating the password.'
      );
    }
  };

  const [isChecked, setIsChecked] = useState(false);

  // const handleCheckboxChange = (event) => {
  //   setIsChecked(event.target.checked);
  // };

  const [notificationPrefs, setNotificationPrefs] = useState({
    action_required: false,
    information: false,
    success: false,
  });

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setNotificationPrefs(prev => ({
      ...prev,
      [name]: checked,
    }));
  };

  const saveNotificationPreferences = async () => {
    try {
      const token = sessionStorage.getItem('authToken');
      await axios.post(
        `${END_URL}user/notification-preferences`,
        notificationPrefs,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setInfoModalMessage('Preferences saved successfully.');
      setShowInfoModal(true);

    } catch (error) {
      setInfoModalMessage('Failed to save preferences.');
      setShowInfoModal(true);
    }
  };

  useEffect(() => {
    const fetchNotificationPrefs = async () => {
      const token = sessionStorage.getItem('authToken');
      if (!token) return;
      try {
        const response = await axios.get(`${END_URL}user/notification-preferences`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data.preferences) {
          setNotificationPrefs({
            action_required: response.data.preferences.action_required,
            information: response.data.preferences.information,
            success: response.data.preferences.success,
          });
        }
      } catch (err) {
        console.error('Failed to load notification preferences', err);
      }
    };
    fetchNotificationPrefs();
  }, []);

  const handleSubmit2FA = async () => {
    setTwoFAError('');
    setTwoFASuccess('');
    if (twoFACode.length !== 6) {
      setTwoFAError('Please enter a valid 6-digit 2FA code.');
      return;
    }

    try {
      const token = sessionStorage.getItem('authToken');
      const response = await axios.post(`${END_URL}2fa`, {
        code: twoFACode,
        email: verificationEmail,
        otp: '2fa',
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      // Check success flag returned by your API explicitly
      if (response.data.success === true) {
        setTwoFASuccess('Two-factor authentication enabled successfully.');
        setShow2FAModal(false);
        setIs2FAEnabled(true); // <-- Update UI state immediately here
      } else {
        setTwoFAError(response.data.message || 'Failed to enable 2FA.');
      }
    } catch (err) {
      setTwoFAError(
        err.response?.data?.message || 'Error occurred while enabling 2FA.'
      );
    }
  };


  return (
    <div className="dashboard-container full-width settings2">
      <Dashheader />
      <div className="container">
        <div className={`row main-row expanded ${expanded1 ? 'mainmenu' : ''}`}>
          <div className="col-12 col-sm-12 col-md-3 col-lg-3">
            <div className="dashboard-side-div">
              <Sidebar />
              <a href="#" className="expand-btn" onClick={(e) => {
                e.preventDefault();
                setExpanded(!expanded1);
              }}><span></span></a>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-md-9 col-lg-9">
            <main className="content">
              <div className="form-container">
                <div className="dashbord-first">
                  <h3>Account Settings & Security</h3>
                  <h5>Manage your account preferences and protect your login details.</h5>
                </div>
                <div className="row">
                  <div className="col-md-8">
                    <div className="settings-container">

                      <div className="card">
                        <h3>Change Password</h3>
                        <div className="form-group">
                          <label>Current Password</label>
                          <input
                            type="password"
                            placeholder=""
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                          />
                        </div>
                        <div className="form-group">
                          <label>New Password</label>
                          <input
                            type="password"
                            placeholder=""
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                          />
                        </div>
                        <div className="form-group">
                          <label>Confirm New Password</label>
                          <input
                            type="password"
                            placeholder=""
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                          />
                        </div>
                        <button onClick={handlePasswordUpdate}>Update Password</button>
                        {error && <p className="error">{error}</p>}
                        {message && <p className="success">{message}</p>}
                      </div>

                      <div className="card">
                        <h3>Notification Preferences</h3>
                        <ul className="prefn">
                          <li>
                            <span>Major Case Updates</span>
                            <input
                              type="checkbox"
                              className="checkstate"
                              name="action_required"
                              checked={notificationPrefs.action_required}
                              onChange={handleCheckboxChange}
                            />
                          </li>
                          <li>
                            <span>Requests for Information</span>
                            <input
                              type="checkbox"
                              className="checkstate"
                              name="information"
                              checked={notificationPrefs.information}
                              onChange={handleCheckboxChange}
                            />
                          </li>
                          <li>
                            <span>Portal Activity Alerts</span>
                            <input
                              type="checkbox"
                              className="checkstate"
                              name="success"
                              checked={notificationPrefs.success}
                              onChange={handleCheckboxChange}
                            />
                          </li>
                        </ul>
                        <button className="set-btn" onClick={saveNotificationPreferences}>Save Preferences</button>
                      </div>

                      <div className="card">
                        <h3>Security Settings</h3>
                        <p>Add an extra layer of security to your account by enabling two-factor authentication (2FA). You'll be asked for a code from your authenticator app when you log in.</p>

                        {is2FAEnabled ? (
                          <button className="set-btn" onClick={handleDisable2FA}>Disable 2FA</button>
                        ) : (
                          <button className="set-btn" onClick={handleEnable2FA}>Enable 2FA</button>
                        )}
                      </div>



                      {show2FAModal && (
                        <div className="modal-overlay">
                          <div className="modal-content">
                            <h3>Enable Two-Factor Authentication</h3>
                            <p>Scan the QR code below with your authenticator app and enter the 6-digit code along with your verification email.</p>
                            {qrCodeUrl && <img src={qrCodeUrl} alt="2FA QR Code" style={{ maxWidth: '200px' }} />}
                            <div className="form-group">
                              <label>2FA Code</label>
                              <input
                                type="text"
                                value={twoFACode}
                                onChange={(e) => setTwoFACode(e.target.value)}
                                maxLength={6}
                                placeholder="Enter 6-digit code"
                              />
                            </div>
                            {/* <div className="form-group">
        <label>Verification Email</label>
        <input
          type="email"
          value={verificationEmail}
          onChange={(e) => setVerificationEmail(e.target.value)}
          placeholder="Enter OTP verification email"
        />
      </div> */}
                            {twoFAError && <p className="error">{twoFAError}</p>}
                            {twoFASuccess && <p className="success">{twoFASuccess}</p>}
                            <div className="button-cta">
                              <button onClick={handleSubmit2FA}>Verify & Enable 2FA</button>
                              <button onClick={() => setShow2FAModal(false)}>Cancel</button>
                            </div>
                          </div>
                        </div>
                      )}





                      <div className="card danger">
                        <h3>Danger Zone</h3>
                        <p>Deactivating your account is permanent and means you will no longer receive updates about this case. Please be certain before proceeding.</p>
                        <button onClick={() => setShowDeactivateModal(true)}>
                          Request Deactivation
                        </button>


                      </div>

                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="settings-container2">
                      <div className="card">
                        <h3>Account Information</h3>
                        <div className={`card-state ${isChecked ? 'checked' : ''}`}>
                          <p>
                            <strong>Name: </strong>
                            {`${userProfile?.name || ''} ${userProfile?.lastname || ''}`.trim() || 'N/A'}
                          </p>
                          <p>
                            <strong>Email: </strong>
                            <a href={`mailto:${userProfile?.email || ''}`}>
                              {userProfile?.email}
                            </a>
                          </p>
                          <p>
                            <strong>Phone: </strong>
                            <a href={`tel:${userProfile?.phone || ''}`}>
                              {userProfile?.phone}
                            </a>
                          </p>

                          {/* <input
                              type="checkbox"
                              className="checkstate"
                              onChange={handleCheckboxChange}
                            /> */}
                        </div>
                      </div>

                      {/* <div className="card">
                          <div dangerouslySetInnerHTML={{ __html: dynamicContent?.settingscontent }} />
                        </div> */}

                      <div className="card">
                        <h3>Recent Login Activity</h3>
                        <ul>
                          {activityLog.length === 0 ? (
                            <p>No activity found</p>
                          ) : (
                            activityLog.slice(0, 6).map((log, index) => (
                              <li key={index}>
                                <strong>{new Date(log.created_at).toLocaleString('en-US', {
                                  hour: 'numeric',
                                  minute: 'numeric',
                                  second: 'numeric',
                                  hour12: true,
                                  day: '2-digit',
                                  month: 'short',
                                  year: 'numeric'
                                })}</strong>: {log.activity}
                                {log.activity === 'Logged in' && ` (IP: ${log.ip_address || 'N/A'})`}


                              </li>
                            ))
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <UserFooter />
            </main>
          </div>
        </div>
      </div>
      {showDeactivateModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h4>Confirm Account Deactivation</h4>
            <p>Are you sure you want to deactivate your account?</p>
            <div className="button-cta">
              <button
                onClick={async () => {
                  try {
                    const token = sessionStorage.getItem('authToken');
                    const response = await axios.post(
                      `${END_URL}deactivate-account-request`,
                      {},
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                          'Content-Type': 'application/json',
                        },
                      }
                    );
                    if (response.status === 200) {
                      sessionStorage.removeItem('authToken');
                      window.location.href = '/';
                    } else {
                      alert('Failed to notify admin.');
                    }
                  } catch (err) {
                    console.error('Deactivation error:', err);
                    alert('Something went wrong while requesting deactivation.');
                  } finally {
                    setShowDeactivateModal(false);
                  }
                }}
              >
                Confirm
              </button>
              <button onClick={() => setShowDeactivateModal(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {showInfoModal && (
        <div className="modal-overlay">
          <div className="modal-content" style={{ textAlign: "center" }}>
            <h4>Notification</h4>
            <p>{infoModalMessage}</p>
            <button style={{ marginInline: "auto" }} onClick={() => setShowInfoModal(false)}>OK</button>
          </div>
        </div>
      )}

    </div>
  );
};

export default SettingsPage;
